import { Component, Vue } from 'vue-property-decorator'
@Component
class NotificationMixin extends Vue {
    public onShowFlashMessage(mess: any, title?: string, variant?: string) {
        let newMess = "";
        if (Array.isArray(mess)) {
            mess.forEach((newMess: string, index: number) => {
                newMess += newMess + "\n";
            });
        } else {
            newMess = mess;
        }
        this.$bvToast.toast(newMess, {
            title: title || "Success",
            variant: variant || "success",
            solid: true,
        });
    }
}
export default NotificationMixin